export default __webpack_public_path__ + "static/media/confirm-btn.c033da37.png";